import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SchwabCallback = () => {
  const [code, setCode] = useState('');
  const [session, setSession] = useState('');
  const [copyStatus, setCopyStatus] = useState('');
  const location = useLocation();

  useEffect(() => {
    // Parse URL parameters
    const urlParams = new URLSearchParams(location.search);
    const codeParam = urlParams.get('code');
    const sessionParam = urlParams.get('session');
    
    if (codeParam) {
      setCode(codeParam);
    }
    if (sessionParam) {
      setSession(sessionParam);
    }
  }, [location]);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopyStatus('Copied!');
      setTimeout(() => setCopyStatus(''), 2000);
    } catch (err) {
      setCopyStatus('Failed to copy');
      setTimeout(() => setCopyStatus(''), 2000);
    }
  };

  const containerStyle = {
    maxWidth: '800px',
    margin: '2rem auto',
    padding: '2rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  };

  const titleStyle = {
    fontSize: '1.5rem',
    marginBottom: '1.5rem',
    color: '#333',
    textAlign: 'center'
  };

  const codeBoxStyle = {
    backgroundColor: '#fff',
    border: '2px solid #e9ecef',
    borderRadius: '6px',
    padding: '1rem',
    marginBottom: '1rem',
    fontFamily: 'monospace',
    fontSize: '0.9rem',
    wordBreak: 'break-all',
    minHeight: '60px',
    position: 'relative'
  };

  const buttonStyle = {
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    marginTop: '0.5rem'
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3'
  };

  const statusStyle = {
    marginLeft: '0.5rem',
    color: copyStatus === 'Copied!' ? '#28a745' : '#dc3545',
    fontSize: '0.8rem'
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>Schwab OAuth Callback</h1>
      
      {code ? (
        <>
          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              Authorization Code:
            </label>
            <div style={codeBoxStyle}>
              {code}
            </div>
            <button
              style={buttonStyle}
              onClick={() => copyToClipboard(code)}
              onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
              onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
            >
              Copy Code
            </button>
            {copyStatus && <span style={statusStyle}>{copyStatus}</span>}
          </div>
          
          {session && (
            <div style={{ marginTop: '1.5rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                Session ID:
              </label>
              <div style={codeBoxStyle}>
                {session}
              </div>
              <button
                style={buttonStyle}
                onClick={() => copyToClipboard(session)}
                onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
              >
                Copy Session
              </button>
            </div>
          )}
        </>
      ) : (
        <div style={{ textAlign: 'center', color: '#666' }}>
          <p>No authorization code found in the URL parameters.</p>
          <p>This page is designed to handle Schwab OAuth callbacks.</p>
        </div>
      )}
    </div>
  );
};

export default SchwabCallback;
